export default {"id":"7591fd4c","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}